import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import gsap from 'gsap'
import './PageTransition.css'

export default function PageTransition() {
  const [isAnimating, setIsAnimating] = useState(false)
  const overlayRef = useRef(null)
  const location = useLocation()
  const isFirstRender = useRef(true)

  useEffect(() => {
    // Skip animation on first render
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    setIsAnimating(true)

    const tl = gsap.timeline({
      onComplete: () => setIsAnimating(false)
    })

    tl.fromTo(
      overlayRef.current,
      { scaleY: 0, transformOrigin: 'bottom' },
      { scaleY: 1, duration: 0.4, ease: 'power4.inOut' }
    )
    .to(overlayRef.current, {
      scaleY: 0,
      transformOrigin: 'top',
      duration: 0.4,
      ease: 'power4.inOut',
      delay: 0.1
    })
  }, [location.pathname])

  return (
    <div className={`page-transition ${isAnimating ? 'active' : ''}`} ref={overlayRef}>
      <div className="transition-content">
        <span className="transition-logo">BIGGUYS</span>
      </div>
    </div>
  )
}
